import React, { useState, useEffect } from 'react'
import Parser from 'html-react-parser';
import $ from 'jquery'

import { HttpClient } from 'actions/HttpClient'
import { RegisterRequestService } from 'actions/HttpCalls'
import { validForm } from 'constants/validFuntions'
// import PropTypes from 'prop-types'

const httpClient = new HttpClient();
const registerRequestService = new RegisterRequestService(httpClient);

function FormSolicitar(props) {
    const {
        tituloSolicitarPlan,
        descSolicitarPlan,
        fi_PLAN,
        planSelected,
        name,
        changeSolicitud
    } = props

    const [email, setEmail] = useState('')
    const [nombres, setNombres] = useState('')
    const [localTelefono, setLocalTelefono] = useState('')
    // const [idSolicitud, setIdSolicitud] = useState(0)
    const [disabledContinua, setDisabledContinua] = useState(false)
    const [inputDisabled, setInputDisabled] = useState(false)
    const [errorCall, setErrorCall] = useState(false)

    
    function validateOnlyNumbersComparador(e) {
        let regex = /^[0-9\b]+$/;
        let inputVal = e.target.value
        if ( inputVal === '' || regex.test(inputVal) ) {
            // console.log("numberssssssssssssssssssssss::::::" + inputVal)
            setLocalTelefono(inputVal)
        }else{
            setLocalTelefono(localTelefono)
        }
    }

    useEffect(()=>{
		validForm('formUserInfo')
	})

    // eslint-disable-next-line
    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    const handleSubmit = event => {
        setErrorCall(false)
        setInputDisabled(true)
        validForm('formUserInfo')
        setDisabledContinua(true)
		console.log('handleSubmit ran');
		event.preventDefault(); // 👈️ prevent page refresh
        let finish = true
		var objectsErrors = []
        objectsErrors = $("span.errorField");
        if (objectsErrors?.length){
            finish = false
            setDisabledContinua(false)
        }
        if(finish){
			submintFormReques()
		}
	};
    async function submintFormReques(){
		const dataBody ={
			"fc_nombre" : nombres,
            "fc_correo" : email,
			"fc_telefono" : localTelefono,
			"fi_plan" : fi_PLAN,
			"fc_nombre_plan" : name,
            "fc_seccion": localStorage.getItem("cotSeccion")
		}
		var jsonSendData = JSON.stringify(dataBody);
		const RegistraSolicitud = await registerRequestService.RegisterRequestItem(jsonSendData);
		console.log("submintFormReques ", RegistraSolicitud)
		if(RegistraSolicitud){
            let data={
                idSolicitud:parseInt(RegistraSolicitud),
                nombres,
                email,
                telefono: localTelefono,
                fi_PLAN,
                name
            }
            setDataReturn(data)
		}else{
			setDisabledContinua(false)
            // setIdSolicitud(0)
            setErrorCall(true)
		}
        setInputDisabled(false)
	}
    function setDataReturn(data){
        changeSolicitud(data)
    }

    return (
        <>
        <form className={'cCotCardsForm' + (planSelected === fi_PLAN ? ' show' : '')} onSubmit={handleSubmit} name="formUserInfo">
                <div className="cCotCardsFormTitle">
                  <h3>{Parser(String(tituloSolicitarPlan))}</h3>
                  <p>{Parser(String(descSolicitarPlan))}</p>
                </div>
                <fieldset>
                  <label>Nombre</label>
                  <input 
                    type="text"
                    placeholder="Pedro Martinez"
                    maxLength='100'
                    name='nombres'
                    value={nombres}
                    onChange={e => setNombres(e.target.value)}
                    disabled={inputDisabled}
                    required
                />
                </fieldset>
                <fieldset>
                  <label>Correo Electr&oacute;nico</label>
                  <input 
                    type="email"
                    placeholder="pedro_martinez@gmail.com" 
                    maxLength='60'
                    name='email'
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    disabled={inputDisabled}
                    required
                  />
                </fieldset>
                <fieldset>
                  <label>Tel&eacute;fono M&oacute;vil</label>
                  <input
                        type="text"
                        maxLength={10}
                        onChange={validateOnlyNumbersComparador}
                        placeholder="Ingresa tu n&uacute;mero"
                        name='localTelefono'
                        value={localTelefono}
                        disabled={inputDisabled}
                        required
                    />
                </fieldset>
                

                <div className="btnCont">
                    <button className="btn btnPrimario" type='submit' id='cot-confirmar' disabled={disabledContinua} >{disabledContinua ? "Enviando..." : "Confirmar"}</button>
                    {/* <button className="btn btnPrimario" type="submit" id='submitFormUser'>Confirmar</button> */}
                </div>
                {
                    errorCall &&
                    <span name="errorCall" class="errorField ">Ha ocurrido un error, vuelva a intentarlo</span>
                }
              </form>
        </>
    )
}

FormSolicitar.defaultProps = {}

// FormSolicitar.propTypes = {}

export default FormSolicitar
